import {Component, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {Product} from '../../models/product';

@Component({
  selector: 'app-product-page',
  templateUrl: './product-page.component.html',
  styleUrls: ['./product-page.component.scss']
})
export class ProductPageComponent implements OnInit {
  products: Product[] = [];

  constructor(
    private actRoute: ActivatedRoute,
  ) {
  }

  ngOnInit(): void {
    this.actRoute.data.subscribe((data: any) => {
      this.products = data.products;
    });
  }

}
